
export enum RedeemStatus {
    pending,
    rejected,
    in_process,
    send,
    completed
}


export enum ReferralStatus {
    pending,
    rejected,
    confirmed
}


export interface CsLevelDto {
  id: number;
  name: string;
  requiredCount: number;
  textHeader: string;
  textBody: string;

  selectedOption: CsLevelOptionDto;
  options: CsLevelOptionDto[];

}

export interface CsLevelOptionDto {
  id: number;
  name: string;
  imageUrl: string;
  textHeader: string;
  textBody: string;
}

export interface CsOverviewDto {
  score: CsScoreDto;
  texts: CsReferralTextsDto;

  redeems: CsRedeemDto[];
  levels: CsLevelDto[];

}

export interface CsRedeemDto {
  id: number;
  redeemedOption: CsLevelOptionDto;
  redeemStatus: RedeemStatus;
}

export interface CsReferralTextsDto {
  referralLink: string;
  referralMessageText: string;
  referralSocialText: string;
  euDescription: string;
}

export interface CsScoreDto {
  pendingReferralCount: number;
  confirmedReferralCount: number;
  redeemedReferralCount: number;
  remainingReferralCount: number;
}
